import { INCREMENT, SET_ZERO, SET_ONE,INCREMENT_COLLAB,SET_ZERO_COLLAB } from "../../actions/types";

const initialState = {
  count: 0,
  collabCount: 0
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INCREMENT:
      return {
        ...state,
        count: state.count + 1
      };
      break;

    case SET_ZERO:
      return {
        ...state,
        count: 0
      };
      break;
    case SET_ONE:
      return {
        ...state,
        count: 0
      };
      break;
    case INCREMENT_COLLAB:
      return {
        ...state,
        collabCount: state.collabCount + 1
      };
      break;

    case SET_ZERO_COLLAB:
      return {
        ...state,
        collabCount: 0
      };
      break;

    default:
      return state;
      break;
  }
};
